import { useEffect, useState } from "react";
import BodyHeader from "../../../components/common/CommonBodyHeader";
import CustomTable from "../../../components/common/CustomTable";
import { loadingReportMasterAsync } from "../../../redux/features/report-master/loadingReportMasterSlice";
import { useDispatch, useSelector } from "react-redux";
import { backdropLoadingAction } from "../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import { useBoolean } from "../../../Hooks/useBoolean";
import { Stack } from "@mui/material";
import DownloadReportButton from "../../../components/common/DownloadReportButton";
import CustomInput from "../../../components/common/CustomInput/CustomInput";
import { performanceReportMasterAsync } from "../../../redux/features/report-master/performanceReportMasterSlice";
import CustomDropdown from "../../../components/common/CustomDropdown/CustomDropdown";
import { useFormik } from "formik";
import { reportDropDownRecordAsync } from "../../../redux/features/report-master/reportDropDownRecordSlice";
import { useNavigate } from "react-router-dom";
import { BsFillEyeFill } from "react-icons/bs";

const aggregateByVehicle = (data) => {
   const items = Array.isArray(data) ? data : Object.values(data || {});

   const grouped = items.reduce((acc, item) => {
      const key = item?.vehicle_no || "Unknown";
      const expenses = parseFloat(item?.expenses) || 0;
      const shortage = parseFloat(item?.shortage) || 0;
      const trips = parseFloat(item?.number_of_trips) || 0;
      const detentation = parseFloat(item?.detentation) || 0;

      if (!acc[key]) {
         acc[key] = {
            ...item,
            expenses: 0,
            shortage: 0,
            number_of_trips: 0,
            detentation: 0,
         };
      }

      acc[key].expenses += expenses;
      acc[key].shortage += shortage;
      acc[key].number_of_trips += trips;
      acc[key].detentation += detentation;

      return acc;
   }, {});

   return Object.values(grouped);
};

export default function PerformanceReport() {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const [records, setRecords] = useState([]);

   const reportMasterList = useSelector(
      (state) => state.performanceReportMasterSlice.data,
   );

   const columns = [
      {
         name: "Vehicle No.",
         selector: (row) => row?.vehicle_no,
         sortable: true,
      },
      {
         name: "Attach Location",
         selector: (row) => row?.attached_location,
         sortable: true,
      },

      {
         name: "Company Name",
         selector: (row) => row?.company_name,
         sortable: true,
      },
      {
         name: "Driver Name",
         selector: (row) => row?.driver_name,
         sortable: true,
      },
      {
         name: "Number of trips",
         selector: (row) => row?.number_of_trips,
         sortable: true,
      },
      {
         name: "Shortage",
         selector: (row) => row?.shortage,
         sortable: true,
      },
      {
         name: "Trip Expendeture",
         selector: (row) => row?.expenses,
         sortable: true,
      },
      {
         name: "Detentation",
         selector: (row) => row?.detentation,
         sortable: true,
      },

      // {
      //    name: "Action",
      //    selector: (row) => (
      //       <button
      //          className="btn"
      //          onClick={() => navigate("/trip/contractual/edit/" + row.tripid)}
      //       >
      //          <BsFillEyeFill
      //             className="text-primary"
      //             style={{ height: "1.5rem", width: "1.5rem" }}
      //          />
      //       </button>
      //    ),
      //    width: "120px",
      //    center: true,
      // },
   ];

   /// fetching filter drop down values
   const dropDownMaster = useSelector((state) => state.reportDropDownRecordSlice);

   const fleetData = [
      { label: "Select..", value: "" },
      ...(dropDownMaster?.data?.vehicle_list?.map?.((item) => ({
         label: item?.vehicle_no,
         value: item?.id,
      })) || []),
   ];

   const companyData = [
      { label: "Select..", value: "" },
      ...(dropDownMaster?.data?.company_list?.map?.((item) => ({
         label: item?.company_name,
         value: item?.id,
      })) || []),
   ];

   const locationData = [
      { label: "Select..", value: "" },
      ...(dropDownMaster?.data?.location_list?.map?.((item) => ({
         label: item?.name,
         value: item?.id,
      })) || []),
   ];

   const driverData = [
      { label: "Select..", value: "" },
      ...(dropDownMaster?.data?.driver_list?.map((item) => ({
         label: item,
         value: item,
      })) || []),
   ];
   const formik = useFormik({
      initialValues: {
         fleet: "",
         location: "",
         company: "",
         driver: "",
         tripCreatedFrom: "",
         tripCreatedTo: "",
      },
   });

   const { errors, values, touched, getFieldProps, handleSubmit, setFieldValue } = formik;

   const reportPopup = useBoolean();

   useEffect(() => {
      dispatch(backdropLoadingAction(true));

      const filter_params = {};
      if (values.company) filter_params.company_id = values.company;
      if (values.fleet) filter_params.vehicle_id = values.fleet;
      if (values.location) filter_params.location_id = values.location;
      if (values.driver) filter_params.driver = values.driver;
      if (values.tripCreatedFrom)
         filter_params.trip_created_from = values.tripCreatedFrom;
      if (values.tripCreatedTo) filter_params.trip_created_to = values.tripCreatedTo;

      dispatch(
         performanceReportMasterAsync({
            data: filter_params,
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   }, [
      values.company,
      values.fleet,
      values.location,
      values.driver,
      values.tripCreatedFrom,
      values.tripCreatedTo,
   ]);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         reportDropDownRecordAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   }, []);

   useEffect(() => {
      if (!reportMasterList) return;

      const aggregated = aggregateByVehicle(reportMasterList).sort((a, b) =>
         (a?.vehicle_no || "").localeCompare(b?.vehicle_no || ""),
      );

      setRecords(aggregated);
   }, [reportMasterList]);

   /*
   const handleDownloadReport = (data) => {
      dispatch(backdropLoadingAction(true));

      const filter_params = { data };

      if (values.company) filter_params.company_id = values.company;
      if (values.fleet) filter_params.vehicle_id = values.fleet;
      if (values.location) filter_params.location_id = values.location;
      if (values.driver) filter_params.driver = values.driver;

      dispatch(
         performanceReportMasterAsync({
            data: filter_params,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },

            done: (report_list) => {
               const headers = [
                  "S. No.",
                  "Vehicle Number",
                  "Attached Location",
                  "Company Name",
                  "Driver Name",
                  "Expenses",
                  "Shortage",
                  "Number Of Trips",
               ];

               let list = Object.values(report_list);

               // ✅ Apply same sorting logic (company → vehicle → customer)
               list.sort((a, b) => {
                  let comp = (a.vehicle_no ?? "").localeCompare(b.vehicle_no ?? "");
                  if (comp !== 0) return comp;

                  comp = (a.attached_location ?? "").localeCompare(
                     b.attached_location ?? ""
                  );
                  if (comp !== 0) return comp;

                  comp = (a.company_name ?? "").localeCompare(b.company_name ?? "");
                  if (comp !== 0) return comp;

                  comp = (a.driver_name ?? "").localeCompare(b.driver_name ?? "");
                  if (comp !== 0) return comp;

                  // customer doesn't exist here → skip
                  return 0;
               });

               const emiArr = [];

               list.forEach((item, index) => {
                  emiArr.push([
                     index + 1,
                     item?.vehicle_no ?? "-",
                     item?.attached_location ?? "-",
                     item?.company_name ?? "-",
                     item?.driver_name ?? "-",
                     item?.expenses ?? "-",
                     item?.shortage ?? "-",
                     item?.number_of_trips ?? "-",
                  ]);
               });

               const sheetData = [headers, ...emiArr];

               const ws = XLSX.utils.aoa_to_sheet(sheetData);
               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "PERFORMANCE REPORT.xlsx");

               dispatch(backdropLoadingAction(false));
               reportPopup.onFalse();
            },
         })
      );
   };
*/

   const handleDownloadReport = (data) => {
      dispatch(backdropLoadingAction(true));

      const filter_params = { data };

      if (values.company) filter_params.company_id = values.company;
      if (values.fleet) filter_params.vehicle_id = values.fleet;
      if (values.location) filter_params.location_id = values.location;
      if (values.driver) filter_params.driver = values.driver;
      if (values.tripCreatedFrom)
         filter_params.trip_created_from = values.tripCreatedFrom;
      if (values.tripCreatedTo) filter_params.trip_created_to = values.tripCreatedTo;

      dispatch(
         performanceReportMasterAsync({
            data: filter_params,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },

            done: (report_list) => {
               const headers = [
                  "S. No.",
                  "Vehicle Number",
                  "Attached Location",
                  "Company Name",
                  "Driver Name",
                  "Expenses",
                  "Shortage",
                  "Number Of Trips",
               ];

               const aggregatedList = aggregateByVehicle(report_list).sort((a, b) =>
                  (a?.vehicle_no || "").localeCompare(b?.vehicle_no || ""),
               );

               const totals = aggregatedList.reduce(
                  (acc, item) => {
                     acc.expenses += item?.expenses || 0;
                     acc.shortage += item?.shortage || 0;
                     acc.trips += item?.number_of_trips || 0;
                     return acc;
                  },
                  { expenses: 0, shortage: 0, trips: 0 },
               );

               const rows = aggregatedList.map((item, index) => [
                  index + 1,
                  item?.vehicle_no ?? "-",
                  item?.attached_location ?? "-",
                  item?.company_name ?? "-",
                  item?.driver_name ?? "-",
                  (item?.expenses ?? 0).toFixed(2),
                  (item?.shortage ?? 0).toFixed(2),
                  item?.number_of_trips ?? 0,
               ]);

               rows.push([
                  "",
                  "",
                  "",
                  "",
                  "GRAND TOTAL",
                  totals.expenses.toFixed(2),
                  totals.shortage.toFixed(2),
                  totals.trips.toFixed(0),
               ]);

               const sheetData = [headers, ...rows];

               const ws = XLSX.utils.aoa_to_sheet(sheetData);
               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

               XLSX.writeFile(wb, "PERFORMANCE_REPORT.xlsx");

               dispatch(backdropLoadingAction(false));
               reportPopup.onFalse();
            },
         }),
      );
   };

   return (
      <div>
         <BodyHeader title="Performance Report" />
         <div className="px-3">
            <div className="row align-items-center">
               <div className="col">
                  <CustomDropdown
                     label="Vehicle Number"
                     optionData={fleetData}
                     value={
                        fleetData.find((option) => option.value === values.fleet) ||
                        fleetData[0]
                     }
                     onChange={(value) => {
                        const val = Array.isArray(value) ? value[0]?.value : value?.value;
                        setFieldValue("fleet", val || "");
                     }}
                  />
               </div>
               <div className="col">
                  <CustomDropdown
                     label="Attach Location"
                     optionData={locationData}
                     value={
                        locationData.find((option) => option.value === values.location) ||
                        locationData[0]
                     }
                     onChange={(value) => {
                        const val = Array.isArray(value) ? value[0]?.value : value?.value;
                        setFieldValue("location", val || "");
                     }}
                  />
               </div>
               <div className="col">
                  <CustomDropdown
                     label="Company"
                     optionData={companyData}
                     value={
                        companyData.find((option) => option.value === values.company) ||
                        companyData[0]
                     }
                     onChange={(value) => {
                        const val = Array.isArray(value) ? value[0]?.value : value?.value;
                        setFieldValue("company", val || "");
                     }}
                  />
               </div>
               <div className="col">
                  <CustomDropdown
                     label="Driver Name"
                     optionData={driverData}
                     value={
                        driverData.find((option) => option.value === values.driver) ||
                        driverData[0]
                     }
                     onChange={(value) => {
                        const val = Array.isArray(value) ? value[0]?.value : value?.value;
                        setFieldValue("driver", val || "");
                     }}
                  />
               </div>
               <div className="col">
                  <CustomInput
                     label="Trip Created From"
                     inputType="date"
                     placeholder="From"
                     {...getFieldProps("tripCreatedFrom")}
                  />
               </div>
               <div className="col">
                  <CustomInput
                     label="Trip Created To"
                     inputType="date"
                     placeholder="To"
                     {...getFieldProps("tripCreatedTo")}
                  />
               </div>
               <div className="col pt-2 mt-2 text-right">
                  <DownloadReportButton
                     title="Download Report"
                     onDownloadReport={handleDownloadReport}
                     confirmPopup={reportPopup}
                  />
               </div>
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
